import React from "react";

import { Card, Label, UnstyledButton } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";
import type { NapiV2Purchase } from "@app/types/napi-v2-purchase-types";

import { NoUpcomingTrips } from "./no-upcoming-trips";
import { TripItem } from "./trip-item";
import { clickedPurchase } from "../../../../../tracking/account-tracking";
import { redirect } from "../../../../../utils/window";

interface Props {
  archived?: boolean;
  purchases: NapiV2Purchase[];
}

export const TripList: React.FC<Props> = ({ archived = false, purchases }) => {
  const { tracker, translator, urlBuilder } = useAppContext();

  if (archived && !purchases.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-300">
      <Label size="lg" fontWeight="bold" as="h2">
        {archived
          ? translator.t("!accounts.my-tickets.past")
          : translator.t("!accounts.my-tickets.upcoming")}
      </Label>
      {!purchases.length ? (
        <NoUpcomingTrips />
      ) : (
        <Card className="flex flex-col">
          {purchases.map(purchase => (
            <UnstyledButton
              key={purchase.id}
              className="after:bg-border-primary relative cursor-pointer border-b-width-hairline border-b-color-primary px-250 py-200 pr-350 transition-all duration-engaging ease-in-out last:border-none hover:shadow-sm sm:p-300"
              onClick={() => {
                tracker.track(clickedPurchase(archived));
                redirect(urlBuilder.accountTrip(purchase.id));
              }}
            >
              <TripItem purchase={purchase} archived={archived} />
            </UnstyledButton>
          ))}
        </Card>
      )}
    </div>
  );
};
